<div class="content-dash">
  <div class="banner-dash"></div>
<div class="dash-column">
  <div class="column">
      <div class="perfil">
      <img [src]="imagenAleatoria" alt="Foto de perfil" />
      <p>Nicolas</p>
      </div>
      <div class="profile-data">
          <!-- <div class="direct">
                <img class="icon" src="../assets/icons/gps.svg" alt="Direcciones">
                <span>Ciudad de Panamá, San  Francisco</span>   
          </div>  -->
          <hr>
          <span><b>{{ 'contentDashboard.profile.phone' | translate }}</b></span>
          <p>6747-2679</p><br>
          <span><b>{{ 'contentDashboard.profile.email' | translate }}</b></span>
          <p> nick&#64;billcentrix.com</p>

      </div>

  </div>
<div class="column">
  <div class="menu-dash">
          <button mat-icon-button class="icon" routerLink="/dashboard/dashboard-content" routerLinkActive="active-button" [routerLinkActiveOptions]="{exact: true}" aria-label="">
            <span>{{ 'contentDashboard.menu.dashboard' | translate }}</span>
          </button>
          <button mat-icon-button class="icon" routerLink="/dashboard/direcciones" routerLinkActive="active-button"   [routerLinkActiveOptions]="{exact: true}"aria-label="">
            <span>{{ 'contentDashboard.menu.addresses' | translate }}</span>
          </button>
          <button mat-icon-button class="icon" routerLink="/dashboard/tarjetas" routerLinkActive="active-button" [routerLinkActiveOptions]="{exact: true}" aria-label="">
            <span>{{ 'contentDashboard.menu.cards' | translate }}</span>
          </button>
          <button mat-icon-button class="icon" routerLink="/dashboard/suscripciones" routerLinkActive="active-button" [routerLinkActiveOptions]="{exact: true}" aria-label="">
            <span>{{ 'contentDashboard.menu.subscriptions' | translate }}</span>
          </button>
  </div>
  <p>
      {{ 'contentDashboard.welcome' | translate: {company: nombreEmpresa} }} 
  </p>
</div>
</div>
</div>
